module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/name/suffix.js
// module id = 1650
// module chunks = 0